import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthLayout } from '@/components/AuthLayout';
import { api } from '@/lib/api';
export function VerifyEmailPage() {
    const [params] = useSearchParams();
    const token = params.get('token') ?? '';
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('');
    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Verification link is missing the token.');
            return;
        }
        api
            .post('/auth/verify-email/', { token })
            .then(() => setStatus('success'))
            .catch((err) => {
            setStatus('error');
            setMessage(err.response?.data?.error?.message ?? 'Verification failed.');
        });
    }, [token]);
    return (_jsxs(AuthLayout, { title: status === 'verifying'
            ? 'Verifying…'
            : status === 'success'
                ? 'Email verified'
                : 'Verification failed', children: [status === 'verifying' && (_jsx("p", { className: "text-sm text-muted-foreground", children: "Hold on while we verify your email." })), status === 'success' && (_jsxs("div", { className: "space-y-4", children: [_jsx("p", { className: "text-sm text-muted-foreground", children: "You can now sign in to your account." }), _jsx(Link, { to: "/login", className: "block w-full rounded-md bg-primary px-3 py-2 text-center text-sm font-medium text-primary-foreground", children: "Sign in" })] })), status === 'error' && (_jsxs("div", { className: "space-y-4", children: [_jsx("p", { className: "text-sm text-destructive", children: message }), _jsx(Link, { to: "/login", className: "block text-center text-sm font-medium text-foreground hover:underline", children: "Back to sign in" })] }))] }));
}
